export default "__VITE_ASSET__FCo1kFea__"